/**
 * Whether a refused payments call means "this account's plan is owned by an Apple In-App Purchase".
 * wix-vmr-repo raises that refusal for checkout and for Undo, switch and cancel on a web subscription
 * Apple replaced, always with "Apple In-App Purchase" in the message. Every route maps it to the same
 * `apple_subscription` code so each screen shows the same App Store notice.
 */
export const APPLE_SUBSCRIPTION_CODE = 'apple_subscription';

export function isAppleSubscriptionRefusal(message: string): boolean {
  return message.toLowerCase().includes('apple in-app purchase');
}
